import React, { FC, ReactNode } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { COLOR_TEXT } from "../../../enums/color";

interface HeaderProps {
  title: string;
  description?: ReactNode;
}
const useStyles = makeStyles((theme) => ({
  header: {
    display: "none",
    "@media (max-width: 768px)": {
      display: "flex",
      alignItems: "end",
      justifyContent: "left",
      flexDirection: "row",
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  },

  headTitle: {
    fontWeight: "bold",
    fontSize: "1.2rem",
    background: COLOR_TEXT.GRADIENT,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  logo: {
    width: 20,
  },

  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      gap: theme.spacing(2),
    },
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.125rem",
    lineHeight: "1.5rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.25rem",
    },
    marginBottom: "0.75rem",
  },
  description: {
    fontSize: "0.875rem",
    color: "#4e5d78",
    lineHeight: "1.25rem",
  },
}));

const Header: FC<HeaderProps> = ({ title, description }) => {
  const classes = useStyles();

  return (
    <Box marginBottom={1.5}>
      <Box className={classes.header}>
        <img className={classes.logo} src={"/assets/svg/logo.svg"} alt=" " />
        <Typography component="h1" className={classes.headTitle}>
          Sapheer
        </Typography>
      </Box>

      <Box className={classes.headerRow}>
        <Typography component="h1" className={classes.title}>
          {title}
        </Typography>
      </Box>
      {description && (
        <Typography component="h6" className={classes.description}>
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default Header;
